import Sortable from "sortablejs";
let el = document.getElementById("portfolio-items");
let sortable = Sortable.create(el, {
  animation: 150,
  ghostClass: "fadded",
  dataIdAttr: "data-id",
  handle: ".portfolio-handle",
  // Called when dragging element changes position
  onUpdate: async function (/**Event*/ evt) {
    const items = sortable.toArray().map(function (x, i) {
      return {
        id: parseInt(x),
        order: i,
      };
    });
    const portfolios = {
      professional: {
        portfolios_attributes: items,
      },
      authenticity_token: $('[name="csrf-token"]')[0].content,
    };
    try {
      hideError();
      showSpinner();
      const data = await postData(document.location + ".json", portfolios);
    } catch (error) {
      showError();
      console.error(error);
    }
    hideSpinner();
  },
});

function showError() {
  document.getElementById("order-error").classList.remove("d-none");
}

function hideError() {
  document.getElementById("order-error").classList.add("d-none");
}

function showSpinner() {
  document.getElementById("order-spinner").classList.remove("d-none");
}
function hideSpinner() {
  document.getElementById("order-spinner").classList.add("d-none");
}

async function postData(url = "", data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    referrer: "no-referrer", // no-referrer, *client
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return await response.json(); // parses JSON response into native JavaScript objects
}
